import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { get_bearer } from '../tools-network';
import BearerMedicalDisplay from '../../../../shared/components/BearerMedicalDisplay';

const EmergencyContactsModal = ({ loginToken, bearerId, onClose, onContactAdded }) => {
	const { t } = useTranslation();
	const [bearerDetails, setBearerDetails] = useState(null);

	useEffect(() => {
		console.log('EmergencyContactsModal mounted, bearerId:', bearerId);
		if (bearerId) {
			loadBearerDetails();
		}
	}, [bearerId]);

	const loadBearerDetails = async () => {
		console.log('Loading bearer details for bearerId:', bearerId);
		try {
			const res = await get_bearer(loginToken, bearerId);
			console.log('get_bearer response:', res);
			if (res.status) {
				console.log('Setting bearer details:', res.data);
				setBearerDetails(res.data);
			} else {
				console.warn('get_bearer returned false status:', res);
			}
		} catch (err) {
			console.error('Failed to load bearer details:', err);
		}
	};

	return (
		<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
			<div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
				<div className="p-6">
					<h2 className="text-2xl font-bold mb-2 text-purple-900">Nu är registreringen klar!</h2>
					<p className="text-gray-600 mb-6">
						Prova gärna att skanna armbandet en gång för att verifiera dess funktion.
					</p>

					{/* PREVIEW SECTION WITH FRAME */}
					<div className="border-2 border-purple-200 rounded-lg p-5 bg-purple-50 mb-6">
						<div className="mb-4">
							<h3 className="text-lg font-semibold text-purple-900 mb-2 flex items-center">
								<svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
								</svg>
								Förhandsgranskning
							</h3>
							<p className="text-sm text-gray-700 italic leading-relaxed">
								Så här kommer det se ut när någon skannar armbandet. Vill du ändra något kan du logga in med BankID och uppdatera informationen.
							</p>
						</div>

						{/* PUBLIC PREVIEW */}
						{bearerDetails ? (
							<div className="bg-white rounded-lg p-4 shadow-md border border-purple-100">
								<BearerMedicalDisplay
									t={t}
									isVerbal={bearerDetails.is_verbal}
									diseases={bearerDetails.diseases || []}
									birthYear={bearerDetails.birth_year}
									sex={bearerDetails.sex}
									bloodType={bearerDetails.blood_type}
								/>
							</div>
						) : (
							<div className="bg-white rounded-lg p-4 shadow-md border border-purple-100 text-center text-gray-500">
								Laddar förhandsgranskning...
							</div>
						)}
					</div>

					<div className="flex justify-center">
						<button
							onClick={onClose}
							className="bg-cyan-500 text-white px-8 py-3 rounded-md hover:bg-cyan-600 transition font-medium shadow-md hover:shadow-lg"
						>
							Klar
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default EmergencyContactsModal;
